

import { IChangeTracking } from "../../../changeTracking/iChangeTracking";


export class RequestPackages implements IChangeTracking {

    private _current: any;

    constructor(private _model: any) {

        this._current = this._model ? angular.copy(this._model) : {};

    }


    get packageId(): number {
        return this._current.packageId;
    }

    set packageId(value: number) {
        this._current.packageId = value;
    }

    get packageType(): string {
        return this._current.packageType;
    }

   
    set packageType(value: string) {
        this._current.packageType = value;
    }

    
    get packageTypeId(): string {
        return this._current.packageTypeId;
    }

    set packageTypeId(value: string) {
        this._current.packageTypeId = value;
    }

    get length(): number {
        return this._current.length;
    }

    set length(value: number) {
        this._current.length = value;
    }


    get width(): number {
        return this._current.width;
    }

    set width(value: number) {
        this._current.width = value;
    }
    get height(): number {
        return this._current.height;
    }

    set height(value: number) {
        this._current.height = value;
    }

    get uom(): string {
        return this._current.uom;
    }

    set uom(value: string) {
        this._current.uom = value;
    }

    get quantity(): number {
        return this._current.quantity;
    }

    set quantity(value: number) {
        this._current.quantity = value;
    }

    get grossWeight(): number {
        return this._current.grossWeight;
    }

    set grossWeight(value: number) {
        this._current.grossWeight = value;
    }

    get isDeleted(): boolean {
        return this._current.isDeleted;
    }

    set isDeleted(value: boolean) {
        this._current.isDeleted = value;
    }

    get recordNumber(): number {
        return this._current.recordNumber;
    }

    set recordNumber(val: number) {
        this._current.recordNumber = val;
    }

    hasChanges(): boolean {

        return !angular.equals(this._current, this._model);
    }

    revert(): void {
        this._current = angular.copy(this._model);
    }

    commit(): void {
        this._model = angular.copy(this._current);
    }

    toJson(): any {
        return this._current;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/models/requestPackages.ts
 **/